<template>
  <div>
    <CardedForm
      ref="categories_form_ref"
      id="categories_form"
      title="_"
      :is_loading="is_loading"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
    >
      <TextField
        v-model="name"
        :validation_rules="name_rules"
        label="Name Of Category"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField>
      <TextField
        v-model="description"
        :validation_rules="description_rules"
        label="Description"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField>
      <v-row no-gutters>
        <v-col no-gutters class="pr-2">
          <TextField
            v-model="icon"
            :validation_rules="icon_rules"
            label="Small Icon"
            icon="mdi-pen-plus"
            :disabled="is_loading"
          ></TextField>
        </v-col>
        <v-col no-gutters class="pl-2">
          <ImageField
            label="Thumbnail Picture"
            icon="mdi-camera"
            :disabled="is_loading"
            folder="categories"
            @on-hide-loader="hide_loader"
            @on-show-loader="show_loader"
            @on-success="on_finished_file_upload"
            @on-error="on_file_upload_errors"
            ref="file_uploader"
            :required="false"
            empty_file_error="No thumbnail image choosen for the category"
            :default_value="default_thumbnail"
          >
          </ImageField>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col no-gutters class="pr-2">
          <SelectField
            v-model="is_top_category"
            :options="['Yes', 'No']"
            :small_chips="false"
            :validation_rules="is_top_category_rules"
            label="Is a Top Category"
            icon="mdi-pen-plus"
            :disabled="is_loading"
          ></SelectField>
        </v-col>
        <v-col no-gutters class="pl-2">
          <SelectField
            v-model="top_category_level"
            :options="[0,1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
            label="Top Category Level"
            icon="mdi-pen-plus"
            :small_chips="false"
            :disabled="is_loading"
          ></SelectField>
        </v-col>
      </v-row>
    </CardedForm>
  </div>
</template>

<script>
import CardedForm from "../../../components/CardedForm";
import TextField from "../../../components/TextField";
import SelectField from "../../../components/SelectField";
import ImageField from "../../../components/ImageField";
import Utils from "../../../lib/Utils";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminCategoriesAdd",
  components: {
    CardedForm,
    TextField,
    SelectField,
    ImageField,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_editing:{
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      errors: [],
      message: "",
      name: "",
      description: "",
      icon: "mdi-file-cabinet",
      thumb_nail: "",
      is_top_category: "No",
      top_category_level: 0,
      name_rules: [
        Utils.validate.is_required("Category name is required"),
        Utils.validate.min_max_length(
          3,
          30,
          "Category name should be between 3 and 30 characters "
        ),
      ],
      icon_rules: [
        Utils.validate.is_required("Icon Is required"),
        Utils.validate.min_max_length(
          3,
          20,
          "Icon name should be between 3 and 20 characters "
        ),
      ],
      description_rules: [
        Utils.validate.max_length(
          60,
          "Description should be less than 60 characters"
        ),
      ],
      is_top_category_rules: [
        Utils.validate.is_required("Is Top Category must be provided"),
      ],
      default_thumbnail: Utils.get_default_category().thumbnail,
      default_icon: Utils.get_default_category().icon,
      id: 0
    };
  },
  methods: {
    on_auto_fill() {
      var rnd = Math.ceil(Math.random() * 456);
      this.name = "Category_" + rnd;
      this.description = rnd + " This is a nice category description ";
      this.icon = this.default_icon;
      this.thumb_nail = this.default_thumbnail;
      this.is_top_category = "No";
      this.top_category_level = 0;
      this.errors = [];
      this.message = "";
    },
    init_editing_form(category){
      this.id = category.id;
      this.name = category.name;
      this.description = category.description;
      this.icon = category.icon;
      this.thumb_nail = category.thumb_nail;
      this.top_category_level = parseInt(category.top_category_level);
      this.is_top_category =  (parseInt(category.is_top_category) == 1)? 'Yes' : 'No';
      this.errors = [];
      this.message = "";
      this.default_thumbnail = category.thumb_nail;
      this.default_icon =  category.icon;
    },
    init_form() {
      this.name = "";
      this.description = "";
      this.icon = this.icon;
      this.thumb_nail = this.thumbnail;
      this.top_category_level = 0;
      this.is_top_category = "No";
      this.errors = [];
      this.message = "";
    },
    hide_loader() {
      this.$emit("on-hide-loader");
    },
    show_loader() {
      this.$emit("on-show-loader");
    },
    on_finished_file_upload(file_url) {
      this.thumb_nail = file_url;
      if(this.is_editing == true){
        this.update_category();
        // console.log("updated category ");
      }else{
         this.post_category();
        //  console.log("post category ");
      }
    },
    on_file_upload_errors(errors) {
      this.errors = errors;
      this.$refs.categories_form_ref.show_error_dialog();
    },
    submit() {
      this.$refs.file_uploader.upload_file();
    },
    post_category() {
      //console.log("This file is ", this.thumb_nail);
      //form is already validated
      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      ServerClient.Categories.post_category(
        {
          
          name: this.name.toLowerCase(),
          description: this.description.toLowerCase(),
          icon: this.icon,
          thumb_nail: this.thumb_nail.toLowerCase(),
          is_top_category: (this.is_top_category == "Yes")? 1 : 0,
          top_category_level: parseInt(this.top_category_level)
        },
        (res) => {
          console.log("add category res",res);
          this.$refs.categories_form_ref.on_clear_form();
          this.init_form();
          this.$emit("on-hide-loader");
          this.message = "<b>Operation was successfull</b> <br/>  New category was added successfully";
          this.$refs.categories_form_ref.show_message_dialog();
        },
        (errors) => {
          this.errors = errors;
          this.$refs.categories_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
    },
    update_category(){
      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      ServerClient.Categories.update_category(
        {
          id: this.id, 
          name: this.name.toLowerCase(),
          description: this.description.toLowerCase(),
          icon: this.icon,
          thumb_nail: this.thumb_nail.toLowerCase(),
          is_top_category: (this.is_top_category == "Yes")? 1 : 0,
          top_category_level: parseInt(this.top_category_level)
        },
        (res) => {
          console.log("edit category res",res);
          this.$emit("on-hide-loader");
          this.message = "<b>Update Operation Was Successfull</b> <br/>  Category was edited successfully";
          this.$refs.categories_form_ref.show_message_dialog();
        },
        (errors) => {
          console.log("errros:", errors);
          this.errors = errors;
          this.$refs.categories_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
    },  
    on_hide_message(){
      if(this.is_editing == true){
        this.$emit("on-success-edit");
      }else{
        this.init_form();
      }
    }
  },
  mounted() {
    this.$emit("set-page-attributes", {
      title: "Add a New Category",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Categories",
          disabled: false,
          href: "/admin/categories",
        },
        {
          text: "New",
          disabled: true,
          href: "/admin/categories/add",
        },
      ],
    });
    this.init_form();
  },
};
</script>